import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';
import { defaultKSK2080_R01Dto, KSK2080_R01Dto } from './Dto_KSK2080_R01';
import { allCd, useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { getFutureWeekday, getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { formatDate } from 'src/utils/string/stringUtil';

export interface KSK2080_R01Filter {
	dateRange: DateRange | undefined;
}

export interface Store_KSK2080_R01 {
	KSK2080_R01Filter: KSK2080_R01Filter;
	KSK2080_R01PastFilter: KSK2080_R01Filter;
	setKSK2080_R01Filter: (filter: Partial<KSK2080_R01Filter>) => void;
	setKSK2080_R01PastFilter: (filter: Partial<KSK2080_R01Filter>) => void;

	KSK2080_R01List: KSK2080_R01Dto[];
	setKSK2080_R01List: (KSK2080_R01List: KSK2080_R01Dto[]) => void;

	selectedKSK2080_R01: KSK2080_R01Dto | undefined;
	setSelectedKSK2080_R01: (item: KSK2080_R01Dto | undefined) => void;
	initSelectedKSK2080_R01: () => void;

	editKSK2080_R01: KSK2080_R01Dto | null;
	setEditKSK2080_R01: (item: KSK2080_R01Dto | null) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultKSK2080_R01Filter : KSK2080_R01Filter = {
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
};

export const useKSK2080_R01Store = create<Store_KSK2080_R01>((set) => ({
	KSK2080_R01Filter: defaultKSK2080_R01Filter,
	KSK2080_R01PastFilter: defaultKSK2080_R01Filter,
	setKSK2080_R01Filter: (filter: Partial<KSK2080_R01Filter>) => set((state) =>  ({
		...state,
		KSK2080_R01Filter: {
			...state.KSK2080_R01Filter,
			...filter
		}	
	})),
	setKSK2080_R01PastFilter: (filter: Partial<KSK2080_R01Filter>) => set((state) =>  ({
		...state,
		KSK2080_R01PastFilter: {
			...state.KSK2080_R01PastFilter,
			...filter
		}	
	})),

	KSK2080_R01List: [],
	setKSK2080_R01List: (KSK2080_R01List: KSK2080_R01Dto[]) => set({ KSK2080_R01List }),

	selectedKSK2080_R01: undefined,
	setSelectedKSK2080_R01: (item: KSK2080_R01Dto | undefined) => set((state) => {

		return { ...state, selectedKSK2080_R01: item };
	}),
	initSelectedKSK2080_R01: () => set({ selectedKSK2080_R01: undefined, editKSK2080_R01: defaultKSK2080_R01Dto }),
	
	editKSK2080_R01: defaultKSK2080_R01Dto,
	setEditKSK2080_R01: (item: KSK2080_R01Dto | null) => set((state) => {
		let editData = defaultKSK2080_R01Dto;
		if (item) {
			editData = { ...item,
				noticeDateRange: {
					from: item.noticeFromDt ? new Date(formatDate(item.noticeFromDt)) : new Date(),
					to: item.noticeEndDt ? new Date(formatDate(item.noticeEndDt)) : new Date(),
				},
			};
		}
		return { editKSK2080_R01: editData };
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	initData: () => set((state) => ({
		...state,
		KSK2080_R01Filter: defaultKSK2080_R01Filter,
		KSK2080_R01PastFilter: defaultKSK2080_R01Filter,
		selectedKSK2080_R01: undefined,
		editKSK2080_R01: defaultKSK2080_R01Dto,
		KSK2080_R01List: [],
		allCount: 0
	})),

	
}));
